import 'regenerator-runtime';
import { isMobile } from './helpers/detect-device';
import pageLoader from './page-loader';

window.addEventListener('load', () => {
  !isMobile().mobile
    ? document.body.classList.add('no-touch')
    : document.body.classList.add('touch');

  pageLoader();
});
